import { loadRuntimeConfig } from './runtime/config.cjs'

loadRuntimeConfig().then(() => import('./appBootstrap')).catch(() => {
  const root = document.getElementById('root')
  root.setAttribute('role', 'alert')
  root.textContent = 'Ошибка конфигурации приложения. Обратитесь к администратору.'
})
